// 画面幅が375px未満のとき、375px幅でデザインされたレイアウトを保ったまま
// ウィンドウ幅にフィットするよう全体を縮小表示する。
//
// meta viewport の width 指定はデスクトップブラウザでは無視されるため、
// 普通のブラウザでウィンドウを狭めても効かない。CSS zoom はレイアウト自体を
// 拡縮し（=リフローして横スクロールも出ない）、デスクトップ／実機の双方で有効。
const BASE_WIDTH = 375;

const applyScale = () => {
  const root = document.documentElement;

  // 計測前に一旦リセットし、zoomの影響を受けない実ビューポート幅を取得する
  root.style.zoom = '';
  const width = root.clientWidth;

  if (width < BASE_WIDTH) {
    // 例: 320px幅 → zoom 0.853 で 375px設計を縮小してフィットさせる
    root.style.zoom = width / BASE_WIDTH;
  }
};

const initViewport = () => {
  applyScale();
  window.addEventListener('resize', applyScale, false);
  window.addEventListener('orientationchange', applyScale, false);
};

export default initViewport;
